import { combineReducers } from 'redux';
import { reducersRaw as decisionReducers } from '../../decision/state/reducers';
import { reducersRaw as folderReducers } from '../../folders/state/reducers';
import { reducersRaw as searchReducers } from '../../search/state/reducers';
import { reducersRaw as userReducer } from '../../user/state/reducers';
import { reducersRaw as userWatchersReducer } from '../../watchers/state/reducers';
import { reducersRaw as notificationsReducer } from '../../navigation/notification/state/reducers';
import { featuresReducer as features } from '../../features/reducers/features';

import { DecisionReducerType } from '../../decision/state/decisionState.types';
import { UserReducerType } from '../../user/state/userState.types';
import { LayoutReducerType } from '../../search/state/reducers/layout';
import {
  FoldersReducerType,
  LatestUpdatedReducerType,
  DecisionsReducerType,
} from '../../folders/state/foldersState.types';
import { ResultsType } from '../../search/state/reducers/results.types';
import { SearchMenuType } from '../../search/state/reducers/searchMenu.types';
import {
  UserWatchersReducerType,
  WatchersReducerType,
} from '../../watchers/state/watchersState.types';
import { QueryParamsType } from '../../search/state/reducers/queryParams.types';
import { NotificationReducerType } from '../../navigation/notification/state/notificationsState.types';
import { FeaturesReducerType } from '../../features/reducers/features.types';
import { WatcherExistsType } from '../../search/state/reducers/watcherExists.types';
import { AggregationsType } from '../../search/search.types';

export type StateType = {
  decision: DecisionReducerType;
  user: UserReducerType;
  layout: LayoutReducerType;
  folders: FoldersReducerType;
  latestUpdated: LatestUpdatedReducerType;
  decisions: DecisionsReducerType;
  results: ResultsType;
  userWatchers: UserWatchersReducerType;
  watchers: WatchersReducerType;
  queryParams: QueryParamsType;
  aggregations: AggregationsType;
  searchMenu: SearchMenuType;
  notifications: NotificationReducerType;
  features: FeaturesReducerType;
  watcherExists: WatcherExistsType;
};

const reducers = combineReducers({
  ...searchReducers,
  ...folderReducers,
  ...decisionReducers,
  ...userReducer,
  ...userWatchersReducer,
  ...notificationsReducer,
  features,
});

export default reducers;
